import parse from "html-react-parser";
import React from "react";
import { arrowNavigationRight } from "../../assets/images/icons";
import {
  isMobile,
  openURL,
} from "../../bridges/BridgeServices";
import "./GrievancesCTA.scss";

const GrievancesCTA = () => {
  const url = "https://share.market/app/contact-us";
  const handleClick = event => {
    if (isMobile()) {
      event.preventDefault();
      openURL(url);
    }
  };
  return (
    <a
      className="grievances-wrapper"
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
    >
      <div className="grievances-cta">Grievances</div>
      <div className="grievances-arrow">
        {parse(arrowNavigationRight)}
      </div>
    </a>
  );
};

export default GrievancesCTA;
